import { util } from "util";

import React, { useState, useEffect } from "react";
//import { confirm } from "react-confirm-box";
import axios from 'axios';
import { saveAs } from "file-saver";
import {Link, NavLink } from "react-router-dom";
import { useLocation } from "react-router";
import $ from 'jquery';
import queryString from 'query-string';

import { useNavigate } from 'react-router-dom'
//var dateFormat = require('dateformat');

	

const RenderWpForm = () => {

const customspremurl=sessionStorage.getItem("CUSTOMSPREMURL");	
const resturl=sessionStorage.getItem("RESTURL");
//var boolFetchingSads=false;

const navigate = useNavigate();

window.addEventListener("keypress", function (event) {
 // detect event keys
 if (event.keyCode == 13) {
   //callsadfinder();
   
 }
});



const [totalamt, setTotalamt] = useState({AMOUNT:0});
const [pmttrxn, setPmttrxn] = useState({ALLOW_CC_PMT:0, id:"",amt:0, url:"", PMT_VCHR_GRP_ID:0});


const [tblvchrs, setTblvchrs] = useState([]);

const [selectedFiles, setSelectedFiles] = useState([]);

const [arrDoc, setArrDoc] = useState([]);

const [reprint, setReprint] = useState({docno:""});
const [dowait, setDowait] = useState({on:false});


const [progress, setProgress] = useState({
perct:null
});


const location = useLocation();


useEffect(() => {

if (sessionStorage.getItem("USERNAME")==null || sessionStorage.getItem("USERNAME")=="null" || sessionStorage.getItem("USERNAME")==undefined || sessionStorage.getItem("USERNAME")==""){
	navigate("/");
	return;
	}//end if

	
	
const queryStringParams = queryString.parse(window.location.search);
if (queryStringParams.trnxid){
	console.log("sess trnxid: "+sessionStorage.getItem("trnxid"));
	console.log("sess lsdocno: "+sessionStorage.getItem("lsdocno"));
	console.log("sess lsamt: "+sessionStorage.getItem("lsamt"));
	if (queryStringParams.trnxid==sessionStorage.getItem("trnxid"))
		postsigtpmttrxn(queryStringParams.trnxid);
	else
		window.alert("Received a mismatching transaction Id #: <br/>"+queryStringParams.trnxid+"<br/>instead of:"+sessionStorage.getItem("trnxid"));
	}//end if
else if (tblvchrs.length<1){
	gettblpmtvchrs();
	}//end if
	
	
	
 },[]);

useEffect(() => {
	
if (pmttrxn.id!="" && pmttrxn.url!=""){
	sessionStorage.setItem("trnxid", pmttrxn.id);
	//window.open(pmttrxn.url);
	window.location=pmttrxn.url;
	}//end if
	
 },[pmttrxn]);
 
useEffect(() => {
	
if (reprint.docno!=""){
	document.getElementById("btn_p_amt").classList.remove("hidden");
	}//end if
	
 },[reprint.docno]);


useEffect(() => {
	
	
if (pmttrxn.PMT_VCHR_GRP_ID>0){
	console.log("pmttrxn.PMT_VCHR_GRP_ID: "+pmttrxn.PMT_VCHR_GRP_ID)
	startpmttrxn(pmttrxn.PMT_VCHR_GRP_ID);
	}//end if
	
 },[pmttrxn.PMT_VCHR_GRP_ID]);



useEffect(() => {
	console.log("arrDoc.length: "+arrDoc.length);
	let lsdocno="", lsamt="";
	let amt=0;
	for (var i=0; i<arrDoc.length; i++){
		amt+=arrDoc[i].AMOUNT;
		if (lsdocno!=""){
			lsdocno+=",";
			lsamt+=",";
			}
		lsdocno+=arrDoc[i].DOC_NO;
		lsamt+=arrDoc[i].AMOUNT;
		console.log("amt: "+amt);
		}//end for
		setTotalamt((prev)=>{
			return {...prev, AMOUNT:amt}
		});
	if (lsdocno!=""){
		console.log("lsdocno: "+lsdocno);
		sessionStorage.setItem("lsdocno", lsdocno);
		sessionStorage.setItem("lsamt", lsamt);
		}
	
		
 },[JSON.stringify(arrDoc)]);

useEffect(() => {
	console.log('selectedFiles.length: '+selectedFiles.length);
	if (selectedFiles.length==1){
		document.getElementById('btnupload').style.visibility='visible';
		if (selectedFiles[0].name!="")
			uploadpmtfile(selectedFiles[0].name);
		}//end if
		
 },[JSON.stringify(selectedFiles)]);


async function postsigtpmttrxn(trxnid){

	if (!trxnid.length){
		window.alert("abort for no trxnid");
		return;
		}
	if (!sessionStorage.getItem("lsdocno")){
		window.alert("abort for no lsdocno in sessionStorage");
		return;
		}
		
const params={
	username:sessionStorage.getItem("USERNAME")
	, arrdocno:sessionStorage.getItem("lsdocno").split(",")
	, arramt:sessionStorage.getItem("lsamt").split(",")
	}
	
		
   const requestOptions = {
      method: 'POST'
	  ,headers: { 'Content-Type': 'application/json' }
	  ,body: JSON.stringify( params )
  };		

 await fetch(resturl+'rarwptapp/postsigtpmttrxn',requestOptions)
      .then(res => res.json())
      .then(res => 	postpmttrxn(res, trxnid) )
      .catch(err => console.log(err));

}//end func


async function postpmttrxn(res, trxnid){
	
	//let temp=arrDoc;
	if (!res.length){
		window.alert("abort for no TAX_TRANS_NO and TAX_SUB_TRANS_NO returned");
		return;
		}

/*
		
	for (var i=0; i<temp.length; i++){
		temp[i].TAX_TRANS_NO=res[i].TAX_TRANS_NO;
		temp[i].TAX_SUB_TRANS_NO=res[i].TAX_SUB_TRANS_NO;
		}//end for
*/

   const requestOptions = {
      method: 'POST'
	  ,headers: { 'Content-Type': 'application/json' }
	  ,body: JSON.stringify( {username:sessionStorage.getItem("USERNAME"), trxnid:trxnid, arrdoc:res} )
  };		

 await fetch(resturl+'rarvsaform/postpmttrxn',requestOptions)
      .then(res => res.json())
      .then(res => 	afterpostpmttrxn(res) )
      .catch(err => console.log(err));

}//end func

async function afterpostpmttrxn(res){
	let POSTED_DATE="";
	
	if (res.length)
		if (res.length==1)
			POSTED_DATE=res[0].POSTED_DATE;
		
	if (POSTED_DATE==""){
		window.alert("abort for no POSTED_DATE received");
		return;
		}
	
	//sessionStorage.getItem("EMAIL")
	const params={
		email:"admin@infodottech.com"
	//	,pmtdate:pmtdate
	, arrdocno:sessionStorage.getItem("lsdocno").split(",")
	//, arramt:sessionStorage.getItem("lsamt").split(",")
	};
	console.log("afterpostpmttrxn");
	
	  const requestOptions = {
      method: 'POST'
	  ,headers: { 'Content-Type': 'application/json' }
	  ,body: JSON.stringify( params )
  };		

 await fetch(resturl+'rarwptapp/printsigdocpdf',requestOptions)
      .then(res => res.json())
      .then(res => 	afterprintsigdoc(res) )
      .catch(err => console.log(err));
}//end func


function afterprintsigdoc(res){
	//if (res.length)
		showsnackbar("Thank you for your payment!");
gettblpmtvchrs();
}//end func

function afterpostpmttrxnOld(res){
	if (res.length)
		showsnackbar("Thank you for your payment!");
	else
		showsnackbar("something went wrong.  please check if payment was deducted before retrying");
}//end func

async function startpmttrxn(PMT_VCHR_GRP_ID){

/*
3115 BED01vl	e1954
  , CASE WHEN LOWER(app.CREATE_USER) LIKE '%ajones%' OR LOWER(app.CREATE_USER) LIKE '%addrianj%' THEN 1 ELSE 0 END AS ALLOW_CC_PMT
  IN SP_TBL_PMT_VCHRS
const dateTime1 = moment(new Date()).format("DDHHmmss");
const tranxnid="5ee7d7c1-af78-4d7e-2025-abb2"+dateTime1;

first generate tranxnid, saving user, amt , start time
next open window (sendpmttrxn) to pmt gateway with tranxnid arg 
next pmt gateway will call (getpmttrxnamt) for amt
*/	
if (!PMT_VCHR_GRP_ID){
	window.alert(" payment transaction could not start.  voucher group id absent ");
	return;
	}
	
   const requestOptions = {
      method: 'POST'
	  ,headers: { 'Content-Type': 'application/json' }
	  ,body: JSON.stringify( {username:sessionStorage.getItem("USERNAME"), amt:totalamt.AMOUNT, PMT_VCHR_GRP_ID:PMT_VCHR_GRP_ID} )
  };		

 await fetch(resturl+'rarvsaform/startpmttrxn',requestOptions)
      .then(res => res.json())
      .then(res => 	afterstartpmttrxn(res) )
      .catch(err => console.log(err));

}//end func

function afterstartpmttrxn(res){
	//showsnackbar("thank you!");
	


	setPmttrxn({
		id:res[0].TRX_ID
		, amt:res[0].AMOUNT
		, url:res[0].URL
	});
}//end func

async function setpmtvchrgrp(e){
	e.preventDefault();
const ARR_DOC_NO=document.getElementsByName('ARR_DOC_NO[]');
var i=0, len=ARR_DOC_NO.length;

/*
let arrDoc=[];
for (i=0; i<len; i++){
	if (ARR_DOC_NO[i].checked==true)
		arrDoc.push({DOC_NO:ARR_DOC_NO[i].value});
	}

*/

   const requestOptions = {
      method: 'POST'
	  ,headers: { 'Content-Type': 'application/json' }
	  ,body: JSON.stringify( {ARR_DOC_NO:arrDoc, VCHR_TYPE:"LC", AMOUNT:totalamt.AMOUNT, USERNAME:sessionStorage.getItem("USERNAME")} )
  };		
setTblvchrs([]);
 await fetch(resturl+'rarwpform/setpmtvchrgrp',requestOptions)
      .then(res => res.json())
      .then(res => 	aftersetpmtvchrgrp(e, res) )
      .catch(err => console.log(err));

}//end func

function aftersetpmtvchrgrp(e, res){

if (selectedFiles.length==1){
	let temp=selectedFiles;
	temp[0].name=res[0].PMT_RCP_FILE;
	setSelectedFiles((prev)=>{
		return [...temp]/*return [...prev, ...temp]*/
	});

	}//end if
else if (selectedFiles.length==0){
	//start online pmt trans
	setPmttrxn((prev)=>{
		return {...prev, PMT_VCHR_GRP_ID:res[0].PMT_VCHR_GRP_ID}
		})//end func
	
	}//end if
	

/*
   const requestOptions = {
      method: 'POST'
	  ,headers: { 'Content-Type': 'application/json' }
	  ,body: JSON.stringify( {ARR_DOC_NO:arrDoc, VCHR_TYPE:"LC", AMOUNT:totalamt.AMOUNT, USERNAME:sessionStorage.getItem("USERNAME")} )
  };		
setTblvchrs([]);
 await fetch(resturl+'rarwpform/setpmtvchrgrp',requestOptions)
*/

}//end func

function selectedFilesChange(event){
//console.log('selectedFilesChange index: '+index);

if (event.target.files.length>1){
	showsnackbar("upload only one file please");
	return;
	}
else if (event.target.files.length==0){
	showsnackbar("no file was received to upload");
	return;
	}
	
	
const fileName=event.target.files[0].name;
var fileExtension = "";
if (fileName.lastIndexOf(".") > 0) 
	fileExtension = fileName.substring(fileName.lastIndexOf(".") + 1, fileName.length);

const lsExtension="pdf";
if (!(", "+lsExtension).includes(", "+fileExtension)){
	document.getElementById("pmtfile").value='';
	showsnackbar("error: the uploaded file must have this extension: "+lsExtension);
	return;
	}//end if		

//if (selectedFiles.length==0)
	//addSubmitEventListener('form1', subEvtLsrCallback);
const i=0;//selectedFiles.length
//console.log('selectedFiles.length: '+i);
let temp=selectedFiles;
temp[i]={file:event.target.files[0], name:''};
setSelectedFiles((prev)=>{
	return [...temp]/*return [...prev, ...temp]*/
});


}//end func



async function uploadpmtfile(PMT_RCP_FILE){
	console.log('uploadpmtfile: '+selectedFiles.length);
	
/*
ensure the below line in node js has the correct array size of 1 
router.post('/uploadfiles', upload.array('filesupload',1), (req, res, next) => {
*/	
const FormData = require('form-data'); // npm install --save form-data

const form = new FormData();
//const pmtreceipt=await fs.readFileSync(rcppath);
form.append('USERNAME', sessionStorage.getItem("USERNAME"));
form.append('REF_NUM', "onlinepmt");
form.append('PMT_RCP_FILE', PMT_RCP_FILE);

const username=sessionStorage.getItem("USERNAME");
const emlcc=username.includes("@")?username:username+"@gov.tc";
//console.log("arrDoc: "+JSON.stringify(arrDoc));

form.append('emlcc', emlcc);
//var jsonBlob = new Blob([JSON.stringify(arrDoc)], { type: 'application/json' });
for (var i=0; i<arrDoc.length; i++){
	form.append('arrDoc[]', arrDoc[i].DOC_NO);
	form.append('arrAmt[]', arrDoc[i].AMOUNT);
	}




if (selectedFiles.length==1){
	const pmtFile=new File([selectedFiles[0].file], selectedFiles[0].name);
	if (pmtFile!=null)	{
		form.append('filesupload', pmtFile);

   
		const request_config = {
			onUploadProgress: data => {
			  //Set the progress value to show the progress bard
			  setProgress({perct:Math.round((100 * data.loaded) / data.total)});
			},
		};
		setDowait({show:true});
		await axios.post(resturl+'rarwpform/uploadonlinepmtfile', form, request_config)
		.then(res => emlpmttotrsy(res.data, form, request_config));
		
		}//end if
	}//end if
	
}//end func

async function emlpmttotrsy(res, form, request_config){
/*
form.append('pmtreceipt', pmtreceipt);
form.append('emlto', wptapp.EMAIL_TO);
res[0].pmtreceipt
UPDATE WPT_APP_UDAK SET
PMT_VCHR_GRP_ID=NULL
ftergettblpmtvc
*/
//console.log("emlpmttotrsy: "+JSON.stringify(res));
if (res[0].pageCount<=0){
	showsnackbar("the uploaded file could not verified as a valid pdf file");
	return;
	}

   const request_config2 ={
	   type: "application/json"
	   
   }
		await axios.post(customspremurl+'rarwptapp/emlpmttotrsy', form, request_config2)
		.then(res => afteremlpmttotrsy(res, form));
		
/*
   const requestOptions = {
      method: 'POST'
	  ,headers: { 'Content-Type': 'application/json' }
	  ,body: JSON.stringify( form )
  };		
setTblvchrs([]);
  fetch(customspremurl+'rarwptapp/emlpmttotrsy',requestOptions)
      .then(res => res.json())
      .then(res => 	afteremlpmttotrsy(res) )
      .catch(err => console.log(err));
*/
}//end func

async function afteremlpmttotrsy(res){
//showsnackbar("you are copied on an email to treasury.  please check that the correct online banking receipt is attached");
await alert("please check your email inbox and ensure the correct online payment receipt is attached");
gettblpmtvchrs();
}//end func



async function gettblpmtvchrs(){


   const requestOptions = {
      method: 'POST'
	  ,headers: { 'Content-Type': 'application/json' }
	  ,body: JSON.stringify( {CREATE_USER:sessionStorage.getItem("USERNAME")} )
  };		
setTblvchrs([]);
  await fetch(resturl+'rarwpform/gettblpmtvchrs',requestOptions)
      .then(res => res.json())
      .then(res => 	aftergettblpmtvchrs(res) )
      .catch(err => console.log(err));

}//end func




function showsnackbar(innerHTML) {
  var x = document.getElementById("snackbar");
  x.innerHTML=innerHTML;
  x.className = "show";
  setTimeout(function(){ x.className = x.className.replace("show", ""); }, 2500);
}//end func



function toggleModalsm() {
if (!document.querySelector(".modalsm"))
	return false;
	
const modalsm = document.querySelector(".modalsm");
	
console.log('modalsm is null: '+(modalsm==null));
modalsm.classList.toggle("show-modalsm");
const isopen=modalsm.classList.contains("show-modalsm");

if (document.querySelector(".close-button")){
	const closeButton = document.querySelector(".close-button");
	if(!closeButton.classList.contains('attached-listener')){
		closeButton.classList.add('attached-listener');
		closeButton.addEventListener("click", toggleModalsm);
		window.addEventListener("click", windowOnClick);
		}//end if
	}//end if
return false;
}//end func



function windowOnClick(event) {
const modalsm = document.querySelector(".modalsm");

if (event.target === modalsm) 
	toggleModalsm();
    
}//end func


async function printsigdocpdf(e){
	e.preventDefault();
	e.target.style.visibility='hidden';
	
	const params={
		email:"admin@infodottech.com"
	, arrdocno:[reprint.docno]
	
	};
	
   const requestOptions = {
      method: 'POST'
	  ,headers: { 'Content-Type': 'application/json' }
	  ,responseType: "blob"
	  ,body: JSON.stringify( params )
  };		
//setTblvchrs([]);
await fetch(customspremurl+'rarwptapp/printsigdocpdf',requestOptions)
     .then(data => 	afterreprintdocpdf(data, e, reprint.docno+".pdf") )
      .catch(err => console.log(err));	
	
	
}//end func


async function afterreprintdocpdf(res, e, filename){
	e.target.style.visibility='visible';
	const blob = await res.blob();
	saveAs(blob, filename);
}//end func	
	

async function getvchrpdffile(e, docNo){
	e.preventDefault();
	e.target.style.visibility='hidden';
	const filename=docNo+".pdf";
	//const filename="RCP.pdf";
	
	
	
   const requestOptions = {
      method: 'POST'
	  ,headers: { 'Content-Type': 'application/json' }
	  ,responseType: "blob"
	  ,body: JSON.stringify( {filename: filename} )
  };		
//setTblvchrs([]);
await fetch(customspremurl+'rarwptapp/getvchrpdffile',requestOptions)
     
      .then(data => 	aftergetvchrpdffile(data, e, filename) )
      .catch(err => console.log(err));	
	
	
}//end func

async function aftergetvchrpdffile(res, e, filename){
	e.target.style.visibility='visible';
	const blob = await res.blob();
	saveAs(blob, filename);
	
/*
const blob = await res.blob();
//console.log('blob.length: '+blob.length);
const data = window.URL.createObjectURL(new Blob([blob]));

const link = document.createElement("a");
link.href = data;
link.setAttribute("download", filename);
document.body.appendChild(link);
link.click();
//link.parentNode!.removeChild(link);	
link.parentNode?.removeChild(link);	
	
	// saveAs(data.getBlob(), filename);
*/

}//end func



function inspect(req){

console.log(
  util.inspect(req, {
    depth: 5,
    colors: true,
  }),
);

}//end func


function clickDoc(e, docNo, amt){
	console.log("clickDoc amt: "+amt);
	let temp=arrDoc;
	if (e.target.checked==true)
		temp.push({DOC_NO:docNo,AMOUNT:amt});
	else{
		temp.splice(temp.findIndex(item => item.DOC_NO === docNo), 1);
		}//end else
		
	if (temp.length==0){
		document.getElementById("pmtfile").value='';
		document.getElementById('divpmtfile').style.visibility="hidden";
		document.getElementById('btnupload').style.visibility="hidden";
		setSelectedFiles([]);
		}
	else
		document.getElementById('divpmtfile').style.visibility="visible";
	
	//console.log(" temp: "+JSON.stringify(temp));
	setArrDoc((prev)=>{
		prev=temp;
		return [...prev]
	});
		//return [...prev, temp]
	//const [name, value]=[e.target.name, e.target.value];
	//if (name=='ARR_DOC_NO[]')
		
}//end func

function aftergettblpmtvchrs(res){
	
	
if (res.length==undefined)
	return;
	
console.log('aftergettblpmtvchrs, res.length: '+res.length);

let htmrows=[];
res.map((col, index) => {
	
	if (index==0)
		setPmttrxn((prev)=>{
			return {...prev, ALLOW_CC_PMT: res[0].ALLOW_CC_PMT}
		});
	
	const docNo=col['DOC_NO'];
	const amt=col['AMOUNT'];
	const trkey='tr_'+index;
	const rdkey='td_'+index;
	const cbId="cb"+index;
	const downloadLink=<a href="#" className="nodecor" id={"link_"+index} onClick={(e)=>{getvchrpdffile(e, docNo);}} ><img src='img/pdf.gif' border='0' />&nbsp;{col['APPLICANT']}</a>;
	
	const htmrow=<tr key={trkey} >
	<td align='right' >{1+index}</td>
	<td align='center' >{amt}</td>
	<td align='left' >
		<input type='checkbox' name='ARR_DOC_NO[]' defaultValue={docNo} id={cbId} onClick={(e)=>{clickDoc(e, docNo, amt);}} />
		<label htmlFor={cbId} className="hand" >{docNo}</label>
	</td>
	<td align='center' >{col['ACCT_DESCP_1']}</td>
	<td align='center' >{col['IMG_REF']}</td>
	<td align='center' >{downloadLink}</td>
	<td align='center' >{col['CREATE_DATE']}</td>
	<td align='center' >{col['DATE_PAID']}</td>
	</tr>;
	htmrows.push(htmrow);
	

});
//	<td align='center' >{col['EMAIL_TREASURY']}</td>

setTblvchrs(htmrows);
}//end func

function format_number(number, num_decimals, include_comma)
{
    return number.toLocaleString('en-US', {useGrouping: include_comma, minimumFractionDigits: num_decimals, maximumFractionDigits: num_decimals});
}




{/*
Paying your receipt vouchers by Direct Deposit to Government's bank account <br/>affords you the luxury of not having
to go to Treasury builing and wait in line for the next available cashier.

This page can help ensure the payment is emailed correctly to the Treasury, so to avoid delays in posting payment.
<br/>Please read the below steps before doing the money transfer via your online banking:
click here to read about Paying your receipt vouchers by Direct Deposit to Government's bank account
*/}

	
  return (<>
  <div align="center" style={{marginTop:"50px"}} >
  Payment vouchers page is currently unavailable pending repairs.
  Apologies for any inconvenience caused.
	  <p>
	  <a href="download/online payments to treasury.pdf" target="_blank" className="nodecor" ><img src="img/pdf.gif" border="0" />&nbsp;TCIG Treasury account info</a>
	  </p>
  </div>

    </>
  );
  


};


export default RenderWpForm;